import { Popconfirm } from 'antd';
import React, { useMemo } from 'react';
import { toCurrency, toPercentage, toRate } from 'utils/utils';
import DataGrid from 'components/DataGrid';
import DeleteButton from 'components/DeleteButton';
import ScheduleButton from 'components/ScheduleButton';
import IfrsScheduleModal from 'components/IfrsScheduleModal';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import ServiceScheduleModal from 'components/ServiceScheduleModal';
import SpreadingScheduleModal from 'components/SpreadingScheduleModal';
import SimpleServElementModal from './SimpleServElementModal';
import { FormInstance } from 'antd/lib/form';
import ConvertButton from 'components/convertButton';
import SimpleCommissionModal from './simpleCommissionModal';
import AdvancedModeModal from './AdvancedModeModal';
import { CheckSquareOutlined, BorderOutlined } from '@ant-design/icons';
import FinancialScheduleModal from 'components/FinancialScheduleModal';
import ModalControllerNV from 'components/ModalControllerNV';

export type ElementsTableProps = {
  onDeleteElement: (element: any) => void;
  onConvertServToFinServ?: (element: any) => void;
  elements: any[];
  contract?: any;
  offerid?: any;
  form?: FormInstance;
  onSave?: (element: any, action: string) => void;
  propsforcalculate?: any;
  debouncedCalculateNew?: () => void;
  currcode?: String;
  phase?: string;
  flagretailer?: boolean;
  catalog?:boolean;
};

const ElementsTable = (props: ElementsTableProps) => {
  const {
    onDeleteElement,
    onConvertServToFinServ,
    elements,
    onSave,
    contract,
    offerid,
    form,
    propsforcalculate,
    currcode,
    phase,
    flagretailer,
    catalog
  } = props;


  // const handleOpenPaymentSchedule = (element: any) => {
  /** @todo */
  // };

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        comcode: 'Element.ctetypelabel',
        dataIndex: 'ctetypelabel',
        width: catalog ? 'hide' : '20%',
        render: (value, record) =>
          record.serviceResponse?.servtypelabel ??
          record.commissionResponse?.commtypelabel ??
          record.ctetype,
        hide: catalog ?? false  
      },
      {
        comcode: 'Element.servcategorylabel',
        dataIndex: 'ctecategorylabel',
        width: catalog ? 'hide' :  '20%',
        render: (value, record) =>
          record.ctetype === 'FIN'
            ? record.ctecategory
            : record.serviceResponse?.servcategorylabel ?? record.ctecategory,
      },

      {
        comcode: 'Element.ctedescription',
        dataIndex: 'ctedescription',
        width: catalog ? 80 : '30%',
        render: (ctedescription, record, index) =>
          record.ctetype === 'SERV' ||
          record.ctetype === 'FEES' ||
          record.ctetype === 'FINSERV' ? (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <a onClick={() => setVisible(true)}>{ctedescription}</a>
              )}
              modal={({ setVisible, visible }) => (
                <SimpleServElementModal
                  offerid={offerid}
                  visible={visible}
                  onClose={() => setVisible(false)}
                  record={record}
                  onSave={onSave!}
                  updateService
                  // form={form}
                  phase={phase}
                  assetamount={propsforcalculate?.assetamount ?? 0}
                  cteduration={propsforcalculate?.cteduration ?? 0}
                  ctefinancedamount={propsforcalculate?.ctefinancedamount ?? 0}
                  ctegraceperiodduration={
                    propsforcalculate?.ctegraceperiodduration ?? 0
                  }
                  cteinvestamount={propsforcalculate?.cteinvestamount ?? 0}
                  ctestartdate={propsforcalculate?.ctestartdate ?? ''}
                  finschedule={propsforcalculate?.finschedule ?? []}
                  index={elements.indexOf(record)}
                  assets={form?.getFieldValue('assets')}
                  cteidparent={form?.getFieldValue('selectedElement')}
                />
              )}
            ></ModalControllerNV>
          ) : record.ctetype === 'COMM' ? (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <a onClick={() => setVisible(true)}>{ctedescription}</a>
              )}
              modal={({ setVisible, visible }) => (
                <SimpleCommissionModal
                  offerid={offerid}
                  visible={visible}
                  onClose={() => setVisible(false)}
                  record={record}
                  onSave={onSave!}
                  updateCommission
                  form={form}
                  assetamount={propsforcalculate?.assetamount ?? 0}
                  cteinvestamount={propsforcalculate?.assetAmount ?? 0}
                  cteduration={propsforcalculate?.cteduration ?? 0}
                  ctefinancedamount={propsforcalculate?.ctefinancedamount ?? 0}
                  ctestartdate={propsforcalculate?.ctestartdate ?? ''}
                  ctegraceperiodduration={
                    propsforcalculate?.ctegraceperiodduration ?? 0
                  }
                  finschedule={propsforcalculate?.finschedule ?? []}
                  index={elements.indexOf(record)}
                />
              )}
            />
          ) : record.ctetype === 'FIN' ? (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <a onClick={() => setVisible(true)}>{ctedescription}</a>
              )}
              modal={({ setVisible, visible }) => (
                <AdvancedModeModal
                  visible={visible}
                  onClose={() => setVisible(false)}
                  form={form!}
                  cteid={record.cteid}
                />
              )}
            />
          ) : (
            ctedescription
          ),
      },
      {
        comcode: 'Element.tpname',
        dataIndex: 'tpname',
        width: catalog ? 'hide' : '20%',
        render: (value, record) =>
          record.serviceResponse?.tpname ??
          record.commissionResponse?.commlabel,
      },
      {
        comcode: 'Element.servbasislabel',
        dataIndex: 'servbasislabel',
        width: catalog ? 50 : '20%',
        render: (value, record) =>
          record.serviceResponse?.servbasislabel ??
          record.commissionResponse?.commbasislabel,
      },

      {
        comcode: 'Element.servcalculationmethodlabel',
        dataIndex: 'servcalculationmethodlabel',
        width: catalog ? 'hide' : '35%',
        render: (value, record) =>
          record.serviceResponse?.servcalculationmethodlabel ??
          record.commissionResponse?.commcalculationmethodlabel,
      },
      {
        comcode: 'perOrFixedAmount',
        dataIndex: 'perOrFixedAmount',
        render: (value, record) =>
          record.serviceResponse
            ? record.serviceResponse?.servcalculationmethod === 'PERCENT'
              ? toPercentage(record.serviceResponse?.servpercentage)
              : toCurrency(
                  record.serviceResponse?.servfixedamount,
                  currcode
                  // record.currcode
                )
            : record.commissionResponse?.commcalculationmethod === 'PERCENT'
            ? toPercentage(record.commissionResponse?.commpercentage)
            : toCurrency(
                record.commissionResponse?.commfixedamount,
                currcode
                // record.currcode
              ),
        width: catalog ? 50 : '20%',
        align: 'right',
      },

      {
        comcode: 'ctebasis',
        dataIndex: 'ctebasis',
        render: (value, record) =>
          record.serviceResponse?.servbasis === 'FINANCING'
            ? toCurrency(record.ctefinancedamount, currcode)
            : record.serviceResponse?.servbasis === 'FREE'
            ? toCurrency(record.servbasis, currcode)
            : toCurrency(record.cteinvestamount, currcode),
        width: catalog ? 'hide' : '20%',
        align: 'right',
      },
      {
        comcode: 'Element.servdurationlabel',
        dataIndex: 'servdurationlabel',
        width: catalog ? 80 : '40%',
        render: (value, record) =>
          record.serviceResponse?.servdurationlabel ??
          record.commissionResponse?.commdurationlabel,
      },

      {
        comcode: 'Element.flagfollowgraceperiod',
        dataIndex: 'flagfollowgraceperiod',
        width: catalog ? 'hide' : '20%',
        align: 'center',
        render: (value, record) =>
          record.pricing?.flagfollowgraceperiod ? (
            <CheckSquareOutlined style={{ color: 'green' }} />
          ) : (
            <BorderOutlined />
          ),
      },

      {
        comcode: 'Element.flagmandatory',
        dataIndex: 'flagmandatory',
        width: catalog ? 'hide' : '20%',
        align: 'center',

        render: (value, record) =>
          record.pricing?.flagmandatory ? (
            <CheckSquareOutlined style={{ color: 'green' }} />
          ) : (
            <BorderOutlined />
          ),
      },
      {
        comcode: 'Element.flagupdate',
        dataIndex: 'flagupdate',
        width: catalog ? 'hide' : '20%',
        align: 'center',
        render: (value, record) =>
          record.pricing?.flagupdate ? (
            <CheckSquareOutlined style={{ color: 'green' }} />
          ) : (
            <BorderOutlined />
          ),
      },
      {
        comcode: 'Element.allowfinservice',
        dataIndex: 'allowfinservice',
        width: catalog ? 'hide' : '20%',
        align: 'center',
        render: (value, record) =>
          record.pricing?.allowfinservice ? (
            <CheckSquareOutlined style={{ color: 'green' }} />
          ) : (
            <BorderOutlined />
          ),
      },

      {
        comcode: 'Element.ctenominalrate',
        dataIndex: 'ctenominalrate',
        render: toRate,
        width: catalog ? 'hide' : '20%',
      },
      {
        comcode: 'Element.cteinstallmentamount',
        dataIndex: 'cteinstallmentamount',
        render: (value, record) => toCurrency(value, currcode),
        fixed: !catalog ? 'right' : false,
        width: catalog ? 50 : '20%',
        align: 'right',
      },

      {
        comcode: 'ctestatuslabel',
        dataIndex: 'ctestatuslabel',
        width: catalog ? 'hide' : '20%',
        fixed: 'right',
      },

      {
        comcode: 'actions',
        key: 'operation',
        render: (text, record) => (
          <div>
            {record.pricing?.allowfinservice &&
              onConvertServToFinServ &&
              record.ctecalculationtype === 'FLAT' && (
                <Popconfirm
                  title="Do you want to finance this element?"
                  onConfirm={() => onConvertServToFinServ(record)}
                >
                  <ConvertButton onlyIcon />
                </Popconfirm>
              )}

            {!record.pricing?.flagmandatory && phase !== 'PROD' && (
              <Popconfirm
                title="Do you want to delete this element?"
                onConfirm={() => onDeleteElement(record)}
              >
                <DeleteButton onlyIcon />
              </Popconfirm>
            )}
            {record.ctetype === 'FINSERV' ? (
              <FinancialScheduleModal
                comcode="P.S"
                flagretailer={flagretailer}
                currcode={currcode ?? record.currcode}
                finElement={record}
                controller={
                  <ScheduleButton
                    size="large"
                    comcode="P.S"
                    twoToneColor="blue"
                  ></ScheduleButton>
                }
              />
            ) : (
              <ServiceScheduleModal
                currcode={currcode ?? record.currcode}
                financialSchedule={record.conElemSchedules}
                flagretailer={flagretailer}
                controller={
                  <ScheduleButton
                    onlyicon
                    comcode="P.S"
                    twoToneColor="blue"
                    style={{
                      height: 40,
                      marginLeft: 5,
                      marginRight: 5,
                      marginBottom: 5,
                    }}
                  />
                }
              />
            )}
            {record.conElemSpreading?.length > 0 ? (
              <SpreadingScheduleModal
                financialSchedule={record.conElemSpreading}
                controller={
                  <ScheduleButton
                    comcode="S.P"
                    twoToneColor="red"
                    style={{
                      height: 40,
                      marginLeft: 5,
                      marginRight: 5,
                      marginBottom: 5,
                    }}
                  />
                }
              />
            ) : null}
            {record.conElemIFRS?.length > 0 ? (
              <IfrsScheduleModal
                financialSchedule={record.conElemIFRS}
                controller={
                  <ScheduleButton
                    comcode="IFRS"
                    twoToneColor="green"
                    style={{
                      height: 40,
                      marginLeft: 5,
                      marginRight: 5,
                      marginBottom: 5,
                    }}
                  />
                }
              />
            ) : null}
          </div>
        ),
        fixed: 'right',
        width: catalog ? 'hide' : phase !== 'PROD' ? '30%' : '20%',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contract, elements, onDeleteElement, onSave, propsforcalculate,flagretailer]
  );

  const rowSelection = {
    onChange: (selectedRowKey: any, selectedRows: any) => {
      let services = [];
      for (const i in selectedRows) {
        services.push(selectedRows[i].cteid);
      }
      selectedRows.forEach((row: any, index: number) => {
        // catalog &&
        //   onSelect({
        //     ...row,
        //   });

      });
    },
  };

  return (
    <DataGrid
      scroll={{ x:!catalog ? 2500 :undefined, y:!catalog ? 900 :200 }}
      columns={columns}
      rowKey={(element) => element.cteid}
      dataSource={elements || []}
      rowSelection={
        catalog ? {
          type: 'checkbox',
          ...rowSelection,
        } : undefined
      }
    />
  );
};

export default ElementsTable;
